var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconService3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_28015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 10.0073V6.79297",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.832 18.5783C11.832 20.1854 13.2677 20.7211 15.0463 20.7211C16.8249 20.7211 18.2606 20.7211 18.2606 18.5783C18.2606 15.364 11.832 15.364 11.832 12.1497C11.832 10.0068 13.2677 10.0068 15.0463 10.0068C16.8249 10.0068 18.2606 10.8211 18.2606 12.1497",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 20.7207V23.935",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0467 29.2927C22.7393 29.2927 28.9753 23.0567 28.9753 15.3641C28.9753 7.67158 22.7393 1.43555 15.0467 1.43555C7.3542 1.43555 1.11816 7.67158 1.11816 15.3641C1.11816 23.0567 7.3542 29.2927 15.0467 29.2927Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_28015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.046875 0.364258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService3);
export default __webpack_public_path__ + "static/media/icon-service-3.fc4cd18130c73b4aaa5a0971ba328b24.svg";
export { ForwardRef as ReactComponent };